import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../../locales/en';
import fr from '../../locales/fr';

const resources = {
    en: {
        translation: en,
    },
    fr: {
        translation: fr,
    },
};

// Initialize with a default language for SSR
i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

// After initial render, detect and change language if needed
if (typeof window !== 'undefined') {
    // Run after React hydration
    setTimeout(() => {
        const browserLang = navigator.language;
        const langCode = browserLang.split('-')[0]; // Get the language code part

        // Only change if it's a supported language and different from current
        if (langCode === 'fr' && i18n.language !== langCode) {
            i18n.changeLanguage(langCode);
        }
    }, 0);
}

export default i18n;
